module.exports = __webpack_public_path__ + "img/ok.da088982.svg";